<template lang="pug">

transition(
  appear
  v-on:enter="enter"
  v-on:leave="leave"
)
  .icon-close
    svg(width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#fff")
      g
        path( :d="`M1 1L${1 + stroke1*25} ${1 + stroke1*25}`" stroke-width="2" stroke-linecap="round")
        path( :d="`M1 26L${1+stroke2*25} ${26-stroke2*25}`" :stroke-width="stroke2w" stroke-linecap="round")

</template>

<script>
  import {TweenMax, TimelineMax, Power2} from 'gsap'
export default {
  name: 'icon-close',
  components: {},
  data() {
    return {
      stroke1: 0,
      stroke2: 0,
      stroke2w: 0
    }
  },
  props: {},
  computed: {},
  mounted() {},
  beforeDestroy() {},
  methods: {
    animateIn(cb) {

      let tl = new TimelineMax({ onComplete: () => {
        cb()
        }})
      this.tl = tl

      tl.add('start')
        .set(
          this.$el,
          {
            transformOrigin: 'center',
            scale: 3.5
          }
        )
        .to(
          this,
          0.7,
          {
            stroke1: 1,
            ease: Power2.easeOut
          },
          `start+=0`
        )
        .to(
          this.$el,
          0.7,
          {
            scale: 1,

          },
          `start+=0`
        )
        .set(
          this,
          {
            stroke2w: 2
          },
          `start+=0.5`
        )
        .to(
          this,
          0.5,
          {
            stroke2: 1,
            ease: Power2.easeOut
          },
          `start+=0.5`
        )

    },
    enter(el, done){
      this.animateIn(done)

    },
    leave(el, done){
      //this.tl.eventCallback('onReverseComplete', done)
      //this.tl.remove(this.staggerTo)
      //console.log(this.tl)
      //this.tl.reverse()

    },
  },
  watch: {
    progress(val){
      console.log(val)
    }
  },
}
</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"
.icon-close
  width: 100%
  height: 100%
  //overflow: hidden









</style>
